(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "module"], factory);
  } else if (typeof exports !== "undefined" && typeof module !== "undefined") {
    factory(exports, module);
  }
})(function (exports, module) {
  "use strict";

  module.exports = "0.13.17";
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/skatejs/lib/version.js
// module id = 30
// module chunks = 0